export const rossListItemClasses = {
  root: 'RossListItem-root',
};
